import { Injectable, Injector } from '@angular/core';


import { Utilities_open_toaster_error_frontflowService } from './Utilities.frontend.flow.index';
import { Utilities_open_toaster_frontflowService } from './Utilities.frontend.flow.index';
import { Utilities_open_toaster_info_frontflowService } from './Utilities.frontend.flow.index';
import { Utilities_open_toaster_success_frontflowService } from './Utilities.frontend.flow.index';
import { Utilities_open_toaster_warning_frontflowService } from './Utilities.frontend.flow.index';

import { $frontendTypes } from './Utilities.frontend.types'

@Injectable({ providedIn: 'root' })
export class Utilities_FrontendFlowService {

  constructor(
    private injector: Injector
  ) {
  }

  public Utilities: Utilities_FrontendFlowService = this;

  // injecting lazily in order to avoid circular dependencies
    
  private _open_toaster_error_frontflow: Utilities_open_toaster_error_frontflowService;
  public async open_toaster_error_frontflow($inParams: { title: string, message?: string }): Promise<void> {
    if(!this._open_toaster_error_frontflow) { 
      this._open_toaster_error_frontflow = this.injector.get(Utilities_open_toaster_error_frontflowService);
    }
    return this._open_toaster_error_frontflow.run($inParams);
  }

   
    
  private _open_toaster_frontflow: Utilities_open_toaster_frontflowService;
  public async open_toaster_frontflow($inParams: { title: string, message?: string, toaster_type: number }): Promise<void> {
    if(!this._open_toaster_frontflow) { 
      this._open_toaster_frontflow = this.injector.get(Utilities_open_toaster_frontflowService);
    }
    return this._open_toaster_frontflow.run($inParams);
  }

   
    
  private _open_toaster_info_frontflow: Utilities_open_toaster_info_frontflowService;
  public async open_toaster_info_frontflow($inParams: { title: string, message?: string }): Promise<void> {
    if(!this._open_toaster_info_frontflow) { 
      this._open_toaster_info_frontflow = this.injector.get(Utilities_open_toaster_info_frontflowService);
    }
    return this._open_toaster_info_frontflow.run($inParams);
  }

   
    
  private _open_toaster_success_frontflow: Utilities_open_toaster_success_frontflowService;
  public async open_toaster_success_frontflow($inParams: { title: string, message?: string }): Promise<void> {
    if(!this._open_toaster_success_frontflow) { 
      this._open_toaster_success_frontflow = this.injector.get(Utilities_open_toaster_success_frontflowService);
    }
    return this._open_toaster_success_frontflow.run($inParams);
  }

   
    
  private _open_toaster_warning_frontflow: Utilities_open_toaster_warning_frontflowService;
  public async open_toaster_warning_frontflow($inParams: { title: string, message?: string }): Promise<void> {
    if(!this._open_toaster_warning_frontflow) { 
      this._open_toaster_warning_frontflow = this.injector.get(Utilities_open_toaster_warning_frontflowService);
    }
    return this._open_toaster_warning_frontflow.run($inParams);
  }

   
}
